// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--xH54Q";
export var featured = "styles-module--featured--4VDYE";
export var background = "styles-module--background--IRCW+";
export var main = "styles-module--main--lHpuZ";
export var title = "styles-module--title--E39nf";
export var grid = "styles-module--grid--T3E1N";